import { render, staticRenderFns } from "./PurchasesDeliveryViewDetailsPurchasesDeliveryItemList.vue?vue&type=template&id=39bb6622&"
import script from "./PurchasesDeliveryViewDetailsPurchasesDeliveryItemList.vue?vue&type=script&lang=js&"
export * from "./PurchasesDeliveryViewDetailsPurchasesDeliveryItemList.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesDeliveryViewDetailsPurchasesDeliveryItemList.vue?vue&type=style&index=0&id=39bb6622&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports